import { useEffect, useState } from 'react';
import { strings } from '../lib/localization';
export function useOnLanguageChange() {
    var _a = useState(), languageCode = _a[0], setLanguageCode = _a[1];
    useEffect(function () {
        var onLanguageChange = function (code) {
            setLanguageCode(code);
        };
        strings.addLanguageChangeListener(onLanguageChange);
        setLanguageCode(strings.getLanguage());
        return function () { return strings.removeLanguageChangeListener(onLanguageChange); };
    }, []);
    return languageCode;
}
